import { JobStatusLiterals } from '@trukt/types/Job';
import { ColorOptionLiterals } from './types';

const TEXT_CLASS_NAME_MAP: Record<JobStatusLiterals, string> = {
  tender: 'text-job-status-tender',
  new: 'text-job-status-new',
  'on hold': 'text-job-status-on-hold',
  ready: 'text-job-status-ready',
  posted: 'text-job-status-posted',
  pending: 'text-job-status-pending',
  declined: 'text-job-status-declined',
  dispatched: 'text-job-status-dispatched',
  'picked up': 'text-job-status-picked-up',
  delivered: 'text-job-status-delivered',
  completed: 'text-job-status-completed',
  canceled: 'text-job-status-canceled',
  deleted: 'text-job-status-deleted',
  'in progress': 'text-job-status-in-progress',
  request: '',
};

const BG_CLASS_NAME_MAP: Record<JobStatusLiterals, string> = {
  tender: 'bg-job-status-tender',
  new: 'bg-job-status-new',
  'on hold': 'bg-job-status-on-hold',
  ready: 'bg-job-status-ready',
  posted: 'bg-job-status-posted',
  pending: 'bg-job-status-pending',
  declined: 'bg-job-status-declined',
  dispatched: 'bg-job-status-dispatched',
  'picked up': 'bg-job-status-picked-up',
  delivered: 'bg-job-status-delivered',
  completed: 'bg-job-status-completed',
  canceled: 'bg-job-status-canceled',
  deleted: 'bg-job-status-deleted',
  'in progress': 'bg-job-status-in-progress',
  request: '',
};

const FILL_CLASS_NAME_MAP: Record<JobStatusLiterals, string> = {
  tender: 'fill-job-status-tender',
  new: 'fill-job-status-new',
  'on hold': 'fill-job-status-on-hold',
  ready: 'fill-job-status-ready',
  posted: 'fill-job-status-posted',
  pending: 'fill-job-status-pending',
  declined: 'fill-job-status-declined',
  dispatched: 'fill-job-status-dispatched',
  'picked up': 'fill-job-status-picked-up',
  delivered: 'fill-job-status-delivered',
  completed: 'fill-job-status-completed',
  canceled: 'fill-job-status-canceled',
  deleted: 'fill-job-status-deleted',
  'in progress': 'fill-job-status-in-progress',
  request: '',
};

export const getJobStatusColorClassName = (
  status: JobStatusLiterals,
  option: ColorOptionLiterals,
) => {
  switch (option) {
    case 'bg':
      return BG_CLASS_NAME_MAP[status];
    case 'fill':
      return FILL_CLASS_NAME_MAP[status];
    default:
      return TEXT_CLASS_NAME_MAP[status];
  }
};
